module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAACXBIWXMAAAsSAAALEgHS3X78AAAA5klEQVQoz52TQXHDUAxEnzIGEAiGYAgugzBoIBiCIQRCgqQugnwIgWAGrxe547rfTVvN7EVaaSWNFCo1i4gjgDpXCeo3AB1QEl2Nc6gojcAdmBL39NUVgTYVZuAEHBOn9BWg/eRn0rAOAlfAxHVTdFj2MiThsppvSVgKdBm7LLEm23lXB56YOkREB7RNJVgi4ga8puumli2v2al8Bs4/qR/4pzW/IUVEDxR1Vvu/KL7ltp8r5q2uyV1EADzUB8AITJV77VdHsMao7iuqExCpLvCSvi+ttrmArZXdt8o55p22+tpLqXwAqNu2pEU5OoIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Tag.png
// module id = 142
// module chunks = 0 1